import { ServiceApplication_Key } from "../../../../config/helpers";
import { IFilterMessage } from "../../../../models/interfaces/IFilterMessage";
import { IMessage, IMessageReturn, IMessagesReturn } from "../../../../models/interfaces/IMessage";

import { apiSlice } from "../../api";

export interface messageApiQueryBody {
    Application_Key: string;
    // eslint-disable-next-line
    Values: any;
}

export const messageApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatereponsemessage: builder.mutation<IMessageReturn, IMessage>({
      query: (data) => {
      const body: messageApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: data,
      };
      return {
        url: "/BO/message/Message_Update_Reponse",
        method: "POST",
        body: body,
      };
    },
  }),
    fetchBOmessages: builder.query<IMessagesReturn, IFilterMessage|undefined>({
    query: (obj) => {
      const body: messageApiQueryBody = {
        Application_Key: ServiceApplication_Key,
        Values: obj,
      };
      return {
        url: "/BO/message/Message_Search",
        method: "POST",
        body: body,
      };
    },
    }),

    fetchBOmessage: builder.query<IMessageReturn, number>({
      query: (id: number) => {
        const body: messageApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: {
            IdMessage: id,
          },
        };
        return {
          url: "/BO/message/Message_Get",
          method: "POST",
          body: body,
        };
      },
      }),


}),
});

export const {
  useLazyFetchBOmessageQuery,
  useFetchBOmessagesQuery,
  useUpdatereponsemessageMutation
 } = messageApi;
